import { State } from 'flow/types/State';

export const getKeyboardShortcuts = (state: State) => state.keyboardShortcuts;
